<template>
    <nav class="panel" v-bind:class="{ 'panel-full-screen': devicePanelFullScreen, 'device-panel-minimized': deviceDetailsPanelMinimized }">
        <DeviceDetails v-if="active" v-bind:class="{'active': active}">
        </DeviceDetails>
        <DeviceListPanel></DeviceListPanel>
    </nav>
</template>

<script>
import DeviceListPanel from './device/DeviceListPanel';
import DeviceDetails from './device/DeviceDetails';
import { mapState } from 'vuex';

export default {
    name: 'Panel',
    components: { DeviceListPanel, DeviceDetails },
    computed: {
        ...mapState({
            deviceDetailsPanelMinimized: state => state.ui.deviceDetailsPanelMinimized,
            devicePanelFullScreen: state => state.ui.devicePanelFullScreen
        }),
        active: function() {
            return this.$store.state.ui.DevicePanelActive;
        }
    }
};
</script>

<style lang="scss">
    .vr {
        width: 2px;
        background-color: $ruler;
        margin: 0 1em;
    }

    .panel {
        left: 0;
        right: 0;
        z-index: 1500;
        display: flex;
        flex-direction: column;
        background-color: $panel-black;

        &.panel-full-screen:not(.device-panel-minimized) {
            height: 100% !important;
            width: 100%;
            position: absolute;
            top: 0;
            transform: initial;
            -webkit-transform: initial;
            transition: none;
            will-change: none;

            .device-bar {
                margin-left: 35px;
            }
        }
    }

    .panel-header {
        padding: 0.5em 0.75em;
        flex: 0 0 auto;
    }

    .panel-footer {
        font-size: x-small;
        padding: 0.3em 0.75em;
        flex: 0 0 auto;
        text-align: center;
    }

    .panel-section {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        transition: transform 0.15s linear;
        will-change: transform;

        .is-small {
            padding-top: 0;
            padding-bottom: 0;
        }
    }

    .spacer {
        flex: 1 1 auto;
    }

    .panel-section-2 {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: $panel-black;
        transform: translateX(-100%);

        .grows {
            /*overflow: scroll*/;
        }
    }

    .panel-section-2.active {
        transform: translateX(0);
    }

    .toolbar-top .toolbar-button {
        color: white;
    }

    .toolbar-top,
    .toolbar-bottom {
        display: flex;
        justify-content: space-around;
        flex: 0 0 auto;
    }

    .toolbar-top {
        justify-content: left;
    }

    .toolbar-button {
        font-size: 1.2em;
        color: $off-white;
        padding: 0 0.5em;
        cursor: pointer;
    }

    .toolbar-button:first-child {
        padding-left: 0;
    }

    .toolbar-button.active {
        color: $primary;
    }

    @media screen and (max-width: 500px) {
        .panel {
            width: 100%;
            position: relative;
            transition: height 0.18s linear;
            will-change: height;
            height: 0;

            &.panel-open {
                height: 270px;
                bottom: 0;
            }

            &.device-panel-minimized {
                height: 85px;

                .tab-content {
                    display: none;
                }
            }
        }

    }

    @media screen and (min-width: 501px) {
        .panel {
            position: fixed;
            width: 370px;
            height: 400px;
            transition: transform 0.18s linear;
            will-change: transform;
        }

        .panel-open {
            transform: translateY(-400px);
            -webkit-transform: translateY(-400px);
        }
    }
</style>
